import { usePage } from '@inertiajs/vue3';

// Fixed UI translations arrive from the backend as an Inertia shared prop
// (`translations`, built by UiTranslations). Keys use dot notation, e.g.
// `t('breadcrumbs.home')` or `t('services.view_all.zabieg')`.

function lookup(translations, key) {
  return String(key)
    .split('.')
    .reduce((acc, part) => (acc == null ? undefined : acc[part]), translations);
}

function interpolate(value, params) {
  if (typeof value !== 'string' || !params) return value;
  return value.replace(/%\{(\w+)\}/g, (match, name) =>
    (params[name] == null ? match : params[name]),
  );
}

/**
 * Resolve a translation key against the shared translations object.
 * Falls back to the key itself when the entry is missing.
 */
export function translate(translations, key, params) {
  const value = lookup(translations || {}, key);
  if (value == null) return key;
  return interpolate(value, params);
}

/** Composition API helper (`<script setup>`). */
export function useTranslations() {
  const page = usePage();
  const t = (key, params) => translate(page.props.translations, key, params);
  return { t };
}

/** Vue plugin exposing `$t` to Options API components and templates. */
export const translationsPlugin = {
  install(app) {
    app.config.globalProperties.$t = function translateGlobal(key, params) {
      return translate(this.$page?.props?.translations, key, params);
    };
  },
};
